{
  "$schema": "https://mux.run/theme.json",
  "name": "Mercury",
  "id": "mercury",
  "light": {
    "palette": {
      "neutral": "#ffffff",
      "ink": "#363644",
      "primary": "#5266eb",
      "accent": "#8da4f5",
      "success": "#036e43",
      "warning": "#a44200",
      "error": "#b0175f",
      "info": "#007f95",
      "interactive": "#465bd1"
    },
    "overrides": {
      "text-weak": "#70707d",
      "syntax-comment": "#70707d",
      "syntax-keyword": "#465bd1",
      "syntax-string": "#036e43",
      "syntax-primitive": "#5266eb",
      "syntax-variable": "#007f95",
      "syntax-property": "#5266eb",
      "syntax-type": "#007f95",
      "syntax-constant": "#a44200",
      "syntax-operator": "#465bd1",
      "syntax-punctuation": "#363644",
      "syntax-object": "#007f95",
      "markdown-heading": "#1e1e2a",
      "markdown-text": "#363644",
      "markdown-link": "#465bd1",
      "markdown-link-text": "#5266eb",
      "markdown-code": "#036e43",
      "markdown-block-quote": "#70707d",
      "markdown-emph": "#a44200",
      "markdown-strong": "#1e1e2a",
      "markdown-horizontal-rule": "#7073931a",
      "markdown-list-item": "#1e1e2a",
      "markdown-list-enumeration": "#5266eb",
      "markdown-image": "#465bd1",
      "markdown-image-text": "#5266eb",
      "markdown-code-block": "#363644"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#171721",
      "ink": "#dddde5",
      "primary": "#8da4f5",
      "accent": "#8da4f5",
      "success": "#77c599",
      "warning": "#fc9b6f",
      "error": "#fc92b4",
      "info": "#77becf"
    },
    "overrides": {
      "text-weak": "#9d9da8",
      "syntax-comment": "#9d9da8",
      "syntax-keyword": "#8da4f5",
      "syntax-string": "#77c599",
      "syntax-primitive": "#8da4f5",
      "syntax-variable": "#77becf",
      "syntax-property": "#a7b6f8",
      "syntax-type": "#77becf",
      "syntax-constant": "#fc9b6f",
      "syntax-operator": "#8da4f5",
      "syntax-punctuation": "#dddde5",
      "syntax-object": "#77becf",
      "markdown-heading": "#ffffff",
      "markdown-text": "#dddde5",
      "markdown-link": "#8da4f5",
      "markdown-link-text": "#a7b6f8",
      "markdown-code": "#77c599",
      "markdown-block-quote": "#9d9da8",
      "markdown-emph": "#fc9b6f",
      "markdown-strong": "#f4f5f9",
      "markdown-horizontal-rule": "#b4b7c81f",
      "markdown-list-item": "#ffffff",
      "markdown-list-enumeration": "#8da4f5",
      "markdown-image": "#8da4f5",
      "markdown-image-text": "#a7b6f8",
      "markdown-code-block": "#dddde5"
    }
  }
}
